import { define } from "@/components/builder/utils"
import { useBuilderStore } from "@/modules/cms/views/post/components/builder/store"

import BasePreview from "./base"

function TemplateBlockPreview({ children }) {
  const { templateBlock: { loading } } = useBuilderStore()

  if (loading) {
    return <div className='p-8 flex items-center justify-center text-gray-500 outline-2 outline-dashed outline-gray-300 bg-gray-50/50 rounded-lg transition-all duration-200 hover:outline-gray-400 hover:bg-gray-100/50'>
      Loading...
    </div>
  }

  return <BasePreview>
    {children}
  </BasePreview>
}

export default define('template-block', TemplateBlockPreview)
  .name('Template Block')
  .build()
